export interface HtmlCompareModel {
  documentId: string;
  url: string;
  fetchUrl: string;
  title: string;
  versionLabel?: string;
  projectId?: string;
  projectName?: string;
  htmlModelDescriptors?: string[];
}

export function filterHtmlCompareModels(
  models: HtmlCompareModel[],
  query: string,
  excludeDocumentId?: string,
): HtmlCompareModel[] {
  const q = query.trim().toLowerCase();
  return models.filter(m => {
    if (excludeDocumentId && m.documentId === excludeDocumentId) return false;
    if (!q) return true;
    const hay = [m.title, m.versionLabel, m.projectName, ...(m.htmlModelDescriptors || [])]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return hay.includes(q);
  });
}

export function filterProjectsForHtmlCompare<T extends { id?: string; name: string; clientName?: string }>(
  projects: T[],
  query: string,
  excludeProjectId?: string,
): T[] {
  const q = query.trim().toLowerCase();
  return projects.filter(p => {
    if (excludeProjectId && p.id && p.id === excludeProjectId) return false;
    if (!q) return true;
    return `${p.name} ${p.clientName || ''}`.toLowerCase().includes(q);
  });
}

export function defaultPreviousHtmlModel(
  siblings: HtmlCompareModel[],
  currentDocumentId: string,
): HtmlCompareModel | null {
  const idx = siblings.findIndex(s => s.documentId === currentDocumentId);
  if (idx >= 0) {
    return siblings[idx + 1] || siblings.slice(0, idx).reverse()[0] || null;
  }
  return siblings.find(s => s.documentId !== currentDocumentId) || null;
}

